import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::llmLatency
* @see app/Http/Controllers/Admin/Platform/SystemController.php:588
* @route '/settings/system/probe/llm-latency'
*/
export const llmLatency = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: llmLatency.url(options),
    method: 'post',
})

llmLatency.definition = {
    methods: ["post"],
    url: '/settings/system/probe/llm-latency',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::llmLatency
* @see app/Http/Controllers/Admin/Platform/SystemController.php:588
* @route '/settings/system/probe/llm-latency'
*/
llmLatency.url = (options?: RouteQueryOptions) => {
    return llmLatency.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::llmLatency
* @see app/Http/Controllers/Admin/Platform/SystemController.php:588
* @route '/settings/system/probe/llm-latency'
*/
llmLatency.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: llmLatency.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::llmLatency
* @see app/Http/Controllers/Admin/Platform/SystemController.php:588
* @route '/settings/system/probe/llm-latency'
*/
const llmLatencyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: llmLatency.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::llmLatency
* @see app/Http/Controllers/Admin/Platform/SystemController.php:588
* @route '/settings/system/probe/llm-latency'
*/
llmLatencyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: llmLatency.url(options),
    method: 'post',
})

llmLatency.form = llmLatencyForm

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::cloudflareModels
* @see app/Http/Controllers/Admin/Platform/SystemController.php:618
* @route '/settings/system/probe/cloudflare-models'
*/
export const cloudflareModels = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cloudflareModels.url(options),
    method: 'post',
})

cloudflareModels.definition = {
    methods: ["post"],
    url: '/settings/system/probe/cloudflare-models',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::cloudflareModels
* @see app/Http/Controllers/Admin/Platform/SystemController.php:618
* @route '/settings/system/probe/cloudflare-models'
*/
cloudflareModels.url = (options?: RouteQueryOptions) => {
    return cloudflareModels.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::cloudflareModels
* @see app/Http/Controllers/Admin/Platform/SystemController.php:618
* @route '/settings/system/probe/cloudflare-models'
*/
cloudflareModels.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cloudflareModels.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::cloudflareModels
* @see app/Http/Controllers/Admin/Platform/SystemController.php:618
* @route '/settings/system/probe/cloudflare-models'
*/
const cloudflareModelsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cloudflareModels.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\SystemController::cloudflareModels
* @see app/Http/Controllers/Admin/Platform/SystemController.php:618
* @route '/settings/system/probe/cloudflare-models'
*/
cloudflareModelsForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cloudflareModels.url(options),
    method: 'post',
})

cloudflareModels.form = cloudflareModelsForm

const probe = {
    llmLatency: Object.assign(llmLatency, llmLatency),
    cloudflareModels: Object.assign(cloudflareModels, cloudflareModels),
}

export default probe